import React from "react";
import ListWrapper from "../../../common/management/ListWrapper";
import DBListPersonContainer from "./DBListPersonContainer";
import DBListTeamContainer from "./DBListTeamContainer";

type Props = {
  handleSearch?: (search: Array<string>) => void;
  clearSearch?: () => void;
  handleAccountType?: (accountType: string) => void;
  currentPage: number;
  perView: number;
  search?: Array<string>;
  accountType?: string;
};

const DBListSELeCT: React.FC<Props> = ({
  handleSearch,
  clearSearch,
  handleAccountType,
  currentPage,
  perView,
  search,
  accountType,
}) => {
  return (
    <ListWrapper
      pageTitle={"データベース一覧"}
      tabs={["プロフィール", "チーム"]}
      clearHandler={clearSearch}
    >
      <DBListPersonContainer
        handleSearch={handleSearch}
        handleAccountType={handleAccountType}
        currentPage={currentPage}
        perView={perView}
        search={search}
        accountType={accountType}
      />
      <DBListTeamContainer
        handleSearch={handleSearch}
        handleAccountType={handleAccountType}
        currentPage={currentPage}
        perView={perView}
        search={search}
        accountType={accountType}
      />
    </ListWrapper>
  );
};

export default DBListSELeCT;
